/**
 * 查询组织机构
 * @param data
 * @returns {Promise<*|undefined>}
 */
import http from "@/utils/http";

export const queryGroup = data => {
    let groupPromise,
        idField = data.idField || data.attributeKey

    switch (data.type) {
        case 1:
        case 2:
        case 3:
            groupPromise = _queryOrg(idField)
            break
        case 4:
            groupPromise = _queryJob(idField)
            break
        case 5:
            groupPromise = _queryGroup(idField)
            break
        case 8:
            groupPromise = _queryLeaderAndMember(idField)
            break
        case 9:
            groupPromise = _queryStudent(idField)
            break
        case 10:
            groupPromise = _queryTeacher(idField)
            break
        default:
            groupPromise = Promise.resolve()
            break
    }

    return groupPromise
}

/**
 * 查询用户
 * @param data
 * @returns {Promise<*|undefined>}
 */
export const queryUser = data => {
    let userPromise,
        idField = data.idField || data.attributeKey

    switch (data.type) {
        case 2:
        case 3:
            userPromise = _queryUser(data.pageIndex, {code: data.code})
            break
        case 4:
            userPromise = _queryUser(data.pageIndex, {jobId: idField})
            break
        case 5:
            userPromise = _queryUserByGroup(data.pageIndex, idField)
            break
        case 6:
            userPromise = _queryUser(data.pageIndex, {loginIdOrName: data.searchKey, validFlag: 0,})
            break
        case 8:
            userPromise = _queryUserByLeader(data.pageIndex, idField)
            break
        case 9:
            userPromise = _queryStudentById(data.pageIndex, idField)
            break
        case 10:
            userPromise = _queryTeacherById(data.pageIndex, idField)
            break
        default:
            userPromise = Promise.resolve()
            break
    }

    return userPromise
}

export const parseItem = item => {
    // 组织机构
    if (item.categoryId == "1" || item.categoryId == "2" || item.categoryId == "3") {
        item.id = item.orgId
        item.idField = item.orgId
        item.nodeType = "group"
        item.type = parseInt(item.categoryId)
        item.textField = item.orgName
        return item
    }
    // 职务
    if (item.isJobTree) {
        item.id = item.idField
        item.nodeType = "group"
        item.type = 4
        return item
    }
    // 群组
    if (item.type == 5) {
        item.id = item.idField
        item.nodeType = "group"
        item.isLeaf = false
        return item
    }
    // 人员
    if (item.humanName) {
        item.idField = item.id
        item.textField = item.humanName
        item.nodeType = "user"
        item.type = 6
        if (item.organizationNames) item.deptNames = _getDeptList(item.organizationNames)
        return item
    }
    // 上下级
    if (item.attributeKey) {
        item.idField = item.attributeKey
        item.textField = item.attributeName
        item.nodeType = "group"
        item.type = 8
        return item
    }

    item.id = item.idField
    item.nodeType = "group"
    return item
}

const _getDeptList = organizationNames => organizationNames.split(',').map(item => item.split(';').pop()).join()

/**
 * 查询组织机构
 * @param orgId
 * @returns {Promise<*|undefined>}
 */
const _queryOrg = (orgId = 0) => http.get(`api/mobile/organization/visible/tree/${orgId}.htm`)

/**
 * 查询职位
 * @param jobId
 * @returns {Promise<*|undefined>}
 */
const _queryJob = (jobId = 0) => http.get(`api/mobile/job/jobTree/${jobId}.htm`)

/**
 * 查询群组
 * @param groupId
 * @returns {Promise<*|undefined>}
 */
const _queryGroup = (groupId = 0) => http.get(`api/mobile/group/queryVisitableGroup/${groupId}.htm`)

/**
 * 查询上下级
 * @returns {Promise<*|undefined>}
 */
const _queryLeaderAndMember = () => http.get(`orgAttribute/orgAttachedAttribute/queryAllList.htm`)

/**
 * 查询教师
 * @returns {Promise<*|undefined>}
 */
const _queryTeacher = () => http.get(`edu/woDeJiaoShi.htm`)

/**
 * 查询学生
 * @returns {Promise<*|undefined>}
 */
const _queryStudent = () => http.get(`edu/woDeRenWu.htm`)

// 默认分页大小
const DEFAULT_PAGE_SIZE = 50

/**
 * 查询人员
 * @param pageIndex
 * @param options
 * @returns {Promise<*|undefined>}
 */
const _queryUser = (pageIndex = 0, options) => http.get(
    `user/visible.htm`,
    {
        ...options,
        pageIndex: pageIndex,
        pageSize: DEFAULT_PAGE_SIZE,
    })

/**
 * 按群组查询人员
 * @param pageIndex
 * @param groupId
 * @returns {Promise<*|undefined>}
 */
const _queryUserByGroup = (pageIndex = 0, groupId = 0) => http.get(
    `groupMember/queryMemberByGroupIdForMobile.htm`,
    {
        groupId: groupId,
        pageIndex: pageIndex,
        pageSize: DEFAULT_PAGE_SIZE,
    })

/**
 * 按上下级查询人员
 * @param pageIndex
 * @param attributeKey
 * @returns {Promise<*|undefined>}
 */
const _queryUserByLeader = (pageIndex = 0, attributeKey = '') => http.get(
    `orgAttribute/orgAttributeConfig/getOrgAttributeValue.htm`,
    {
        key: attributeKey,
        pageIndex: pageIndex,
        pageSize: DEFAULT_PAGE_SIZE,
    })

/**
 * 按id查询学生
 * @param pageIndex
 * @param id
 * @returns {Promise<*|undefined>}
 */
const _queryStudentById = (pageIndex = 0, id = 0) => http.get(
    `edu/xuanKeXueSheng.htm`,
    {
        idField: id,
        pageIndex: pageIndex,
        pageSize: DEFAULT_PAGE_SIZE,
    })

/**
 * 按id查询老师
 * @param pageIndex
 * @param id
 * @returns {Promise<*|undefined>}
 */
const _queryTeacherById = (pageIndex = 0, id = 0) => http.get(
    `edu/shouKeJiaoShi.htm`,
    {
        idField: id,
        pageIndex: pageIndex,
        pageSize: DEFAULT_PAGE_SIZE,
    })